/**
 * Throttle utility for capability monitoring logs.
 * Ensures each capability is logged only once per SDK instance (permanent tracking).
 *
 * Key format: `${capability}`
 */
export class CapabilityThrottle {
  private loggedCapabilities = new Set<string>();

  /**
   * Check if a capability has already been logged
   * @param capability - Unique capability identifier (e.g., 'clipboard-write')
   * @returns true if already logged, false otherwise
   */
  isThrottled(capability: string): boolean {
    return this.loggedCapabilities.has(capability);
  }

  /**
   * Mark a capability as logged
   * @param capability - Unique capability identifier
   */
  updateThrottle(capability: string): void {
    this.loggedCapabilities.add(capability);
  }

  /**
   * Clear all logged capabilities (useful for cleanup/testing)
   */
  clear(): void {
    this.loggedCapabilities.clear();
  }
}
